import axios from "axios";
import { useEffect, useState } from "react";
import { url } from '../utils/config';
import Table from "../reusable_components/Table";
import { toast } from "react-toastify";
import pdfIcon from '../assets/pdf-icon.png'
import { title, btnOneNoWidth } from "../utils/style";
import AddManual from "../modals/AddManual";
import Button from "../reusable_components/Button";

function CarsAndManuals() {
    const [carId, setCarId] = useState(null);
    const [technicianManual, setTechnicianManual] = useState(null);
    const [userManual, setUserManual] = useState(null);
    const [showForm, setShowForm] = useState(false)
    const [reloadTable, setReloadTable] = useState(false)

    useEffect(() => { uploadManual() }, [userManual, technicianManual])


    function addManual(e) {
        if (e.target.name === 'userManual') {
            setUserManual(e.target.files[0])
        } else if (e.target.name === 'technicianManual') {
            setTechnicianManual(e.target.files[0])
        }

    }

    async function uploadManual() {
        try {
            if (carId && (technicianManual || userManual)) {
                const formData = new FormData();
                formData.append('carId', carId);
                if (userManual) {
                    formData.append('type', 'user');
                    formData.append('pdf', userManual)
                };
                if (technicianManual) {
                    formData.append('type', 'technician');
                    formData.append('pdf', technicianManual);
                }

                const reqUrl = url + '/manual';
                const token = window.localStorage.getItem('token');
                const headers = { authorization: `bearer ${token}` };
                const { data } = await axios.patch(reqUrl, formData, { headers });
                setCarId(null);
                setUserManual(null);
                setTechnicianManual(null);
                toast.success(data.message, { autoClose: 3000 })
                setReloadTable(1 + Math.random())
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message, { autoClose: 3000 })
        }
    }

    const options = [
        {
            header: 'S. No.',
            key: 'id',
            width: "15%"
        },
        {
            header: 'Make',
            key: 'make',
            width: "25%"
        },
        {
            header: 'Model',
            key: 'model',
            width: "40%"
        },
        {
            header: 'Year',
            key: 'year',
            width: "20%"
        },
        // {
        //     header: 'User Manual',
        //     render: (data, ind) => {
        //         return(
        //             data?.manual?.userManual ?
        //             <span className="flex items-center justify-center">
        //                 <img src={pdfIcon} width={40} />
        //             </span> 
        //             :
        //             <span>
        //                 <label 
        //                     htmlFor={'um' + ind} 
        //                     className="bg-blue-500 px-4 py-1 cursor-pointer mr-8" 
        //                     onClick={() => setCarId(data.id)}
        //                 >
        //                     Upload
        //                 </label>
        //                 <input 
        //                     className="hidden" 
        //                     id={'um' + ind} 
        //                     type="file" 
        //                     name="userManual" 
        //                     accept="application/pdf" 
        //                     onChange={e => addManual(e)} 
        //                 />
        //             </span>
        //         )
        //     }
        // },
        // {
        //     header: 'Technician Manual',
        //     render: (data, ind) => {
        //         return(
        //             data?.manual?.technicianManual ?
        //             <span className="flex items-center justify-center">
        //                 <img src={pdfIcon} width={40} />
        //             </span> 
        //             :
        //             <span>
        //                 <label 
        //                     htmlFor={'tm' + ind} 
        //                     className="bg-blue-500 px-4 py-1 cursor-pointer mr-8" 
        //                     onClick={() => setCarId(data.id)}
        //                 >
        //                     Upload
        //                 </label>
        //                 <input 
        //                     className="hidden" 
        //                     id={'tm' + ind} 
        //                     type="file" 
        //                     name="technicianManual" 
        //                     accept="application/pdf" 
        //                     onChange={e => addManual(e)} 
        //                 />
        //             </span>
        //         )
        //     }
        // }
    ]

    const excludeFilter = ['S. No.', 'User Manual', 'Technician Manual']
    return (
        <div className="p-4">
            {
                showForm && <AddManual setShowForm={setShowForm} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Cars & Manuals</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`New Manual`} clickHandler={() => setShowForm(!showForm)} />
                )}
            </div>
            <Table
                options={options}
                url={url + '/cars'}
                pagination
                btnTitle={'New Manual'}
                clickHandler={() => setShowForm(!showForm)}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default CarsAndManuals;